/**
 * @file src/components/Layouts/PageContentLayout/PageContentLayoutStyles.tsx
 * @exports Header, TitleBox, SearchBox, SearchAndFilterContainer
 * @summary styled-components for PageContentLayout component
 */

import { colors } from "@cerebruminc/cerebellum";
import styled from "styled-components";
import type { SearchBoxProps } from "./types";

export const Header = styled.div`
  align-items: center;
  background-color: ${colors.WHITE};
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  margin-bottom: 8px;
  padding: 20px 28px 20px 20px;
  top: 75px;
  z-index: 2;
`;

export const TitleBox = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-start;
`;

export const SearchBox = styled.div<SearchBoxProps>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;

  ${({ $hasError, theme }) =>
		$hasError &&
		`
    input {
      border-color: ${theme.input?.failColor || colors.RED_100} !important;
    }
  `}
`;

export const SearchValidationMessage = styled.p`
  color: ${({ theme }) => theme.input?.failColor || colors.RED_100};
  font-size: 14px;
  margin: 0;
`;

export const SearchAndFilterContainer = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: 30px;
`;
